import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/laboratory/kit-check-in/:id',
  title: 'Kit',
  endpoint: '/app/kit',
  breadcrumbs: [],
}
